import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import axios from "axios";
import { FaUnderline } from "react-icons/fa";

Footer.propTypes = {
    
};

function Footer(props) {
    return (
        <footer className="footer" style={{paddingTop:"30px"}}>
              
                <div className="inner-footer" style={{padding: "20px 20px"}}>
                <div className="tf-container">
                    <div className="row" style={{paddingLeft:"5%", paddingRight:"5%"}}>
                    <div className="col-lg-4 col-md-6">
                        <div className="footer-cl-1">
                        <div className="icon-infor d-flex aln-center">
                            <div className="icon">
                            <span className="icon-call-calling"><span className="path1"></span><span className="path2"></span><span
                                className="path3"></span><span className="path4"></span></span>
                            </div>
                            <div className="content">
                            <p>Need help? 24/7</p>
                            <h6><Link to={`tel:918960708425`}>+91-8960708425</Link></h6>
                            </div>
                        </div>
<p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
<p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline", color:"#14a077"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline", color:"#14a077"}}>info@adhigyanam.com</Link></p>

                        
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-6 col-6">
                        <div className="footer-cl-2">
                        <h6 className="ft-title">
                            Quick Links
                        </h6>
                        <ul className="navigation-menu-footer">
                            <li> <Link to="/about">About Us</Link> </li>
                            <li> <Link to="/horoscopesall">Horoscopes</Link> </li>
                            <li> <Link to="/userdashboard">My Account</Link> </li>
                            <li> <Link to="/registration">Register With Us</Link> </li>
                            <li> <Link to="/feedbacks">Customer Reviews</Link> </li>
                        </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-4 col-6">
                        <div className="footer-cl-3">
                        <h6 className="ft-title">
                            eLearning
                        </h6>
                        <ul className="navigation-menu-footer">
                            <li> <Link to="/coursecategories">Course Categories</Link> </li>
                            <li> <Link to="/allcourses">All Courses</Link> </li>
                            <li> <Link to="/userdashboard">My Courses</Link> </li>
                            <li> <Link to="/userdashboard">Start Learning</Link> </li>
                            <li> <Link to="/cart">Cart</Link> </li>
                           
                        </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-4 col-6">
                    <div className="footer-cl-4">
                        <h6 className="ft-title">
                            eConsultation
                        </h6>
                        <ul className="navigation-menu-footer">
                            <li> <Link to="/allastrologers">All Astrologers</Link> </li>
                            <li> <Link to="/astroservices">Consult Now</Link> </li>
                            <li> <Link to="/feedbacks">Feedbacks</Link> </li>
                            <li> <Link to="/astrologerreg">Work With Us</Link> </li>
                            <li> <Link to="/astrologerlogin">Login As Astrologer</Link> </li>
                        </ul>
                        </div>
                    </div>
                     <div className="col-lg-2 col-md-4 col-6">
                        <div className="footer-cl-4">
                        <h6 className="ft-title">
                            ePooja & More
                        </h6>
                        <ul className="navigation-menu-footer">
                            <li> <Link to="/epooja">ePooja Guides</Link> </li>
                            <li> <Link to="/userdashboard">My Bookings</Link> </li>
                            <li> <Link to="/blogs">Official Blog</Link> </li>
                            <li> <Link to="/blogcategories">Blogs By Category</Link> </li>
                             <li> <Link to="/support"><b>FAQ & Support</b></Link> </li>
                        </ul>
                        </div>
                    </div>
                    </div>
                     <div className="row" style={{paddingLeft:"5%", paddingRight:"5%", width:"100%", textAlign:"center", marginTop:"12px"}}>

                       
    <ul className="list-social d-flex aln-center" style={{width:"auto", margin:"auto"}}>
                                <li><Link to="https://www.facebook.com/Adhigyanam" style={{border:"solid #8FBC8F 2px"}}><i className="icon-facebook"></i></Link></li>
                                <li><Link to="https://www.instagram.com/the_vedic_astro" style={{border:"solid #8FBC8F 2px"}}><i className="icon-instagram1"></i></Link></li>
                                <li><Link to="https://x.com/adhigyanam" style={{border:"solid #8FBC8F 2px"}}><i className="icon-twitter"></i></Link></li>
                            </ul>
                        
                     </div>
                    
                </div>
                </div>
                <div className="bottom">
                <div className="tf-container" style={{paddingLeft:"5%", paddingRight:"5%"}}>
                    <div className="row">
                    <div className="col-lg-6 col-md-6">
                        <div className="bt-left">
                        <div className="copyright">©2025 <b>Sauntesthyam LLP</b>. All Rights Reserved.</div>
                       
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <ul className="menu-bottom d-flex aln-center">
                        <li><Link to="/usageterms">Usage Terms</Link> </li>
                        <li><Link to="/privacypolicy">Privacy Policy</Link> </li>
                        <li><Link to="/shippingpolicy">Shipping Policy</Link> </li>
                        <li><Link to="/refundpolicy">Refunds</Link> </li>
                         <li><Link to="/legalpolicy">Legal</Link> </li>
                        </ul>
                    </div>
                    </div>
                </div>
                </div>
            </footer>
    );
}

export default Footer;